/** @format */

import React, { useEffect, useState } from 'react'
import { getData } from '../../../../../../../Helpers/webApi'
import localize from '../../../../../../../Global/Localize'
import { formatDate } from '../../../../../../../Helpers/formatters'
import Tab from '../../../../../../../Components/Tabs/Tab'
import { ViewPurchaseRequisitionEntries } from './ViewPurchaseRequisitionEntries'
import { ViewPurchaseRequisitionApprovals } from './ViewPurchaseRequisitionApprovals'

export const ViewPurchaseRequisitionModal = ({
  selectedPurchaseRequisition,
}) => {
  const [reqParams, setReqParams] = useState({
    quotationId: selectedPurchaseRequisition?.id,
    text: '',
    pageIndex: 0,
    pageSize: 10,
  })
  const [quotationEntries, setQuotationEntries] = useState([])
  const [approvals, setApprovals] = useState([])

  const fetchRequisitionItems = async () => {
    const { success, data } = await getData(
      '/PurchaseRequisition/find-purchase-requisitions-items-by-purchase-requisition-id-filter-in-page',
      {
        ...reqParams,
        purchaseRequisitionId: selectedPurchaseRequisition?.id,
      },
      false,
    )
    if (success) {
      setQuotationEntries(data)
    }
  }

  const fetchApprovals = async () => {
    const { success, data } = await getData(
      '/PurchaseRequisition/find-purchase-requisitions-approvals',
      {
        purchaseRequisitionId: selectedPurchaseRequisition?.id,
      },
      false,
    )
    if (success) {
      setApprovals(data?.result)
    }
  }

  useEffect(() => {
    fetchApprovals()
  }, [selectedPurchaseRequisition?.id])

  useEffect(() => {
    fetchRequisitionItems()
  }, [selectedPurchaseRequisition?.id, reqParams])

  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-2 text-capitalize">
            {localize('department')}
          </label>
          <input
            value={selectedPurchaseRequisition?.departmentDescription}
            disabled
            className={'form-control'}
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('expectedDate')}
          </label>
          <input
            className="form-control"
            disabled
            value={formatDate(selectedPurchaseRequisition?.expectedDate, true)}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-2 text-capitalize">
            {localize('createdBy')}
          </label>
          <input
            className="form-control"
            value={selectedPurchaseRequisition?.createdBy}
            disabled
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('createdDate')}
          </label>
          <input
            disabled
            className="form-control"
            value={formatDate(selectedPurchaseRequisition?.createdDate)}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-1 text-capitalize">{localize('branch')}</label>
          <input
            className="form-control"
            disabled
            value={selectedPurchaseRequisition?.branchDescription}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-12">
          <div
            className="p-2 mt-4"
            style={{
              border: 'solid 1px #0000001f',
              borderRadius: 10,
              position: 'relative',
            }}
          >
            <Tab
              tabItems={[
                {
                  label: localize('purchaseRequisitionItems'),
                  item: (
                    <ViewPurchaseRequisitionEntries
                      entries={quotationEntries}
                      setReqParams={setReqParams}
                      reqParams={reqParams}
                    />
                  ),
                },
                {
                  label: localize('approvals'),
                  item: (
                    <ViewPurchaseRequisitionApprovals entries={approvals} />
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  )
}
